// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__316n4","col":"styles_col__3HCFb","actions":"styles_actions__2OpyZ","conflict":"styles_conflict___NTU7"};